export default __webpack_public_path__ + "static/media/what-we-do-medium-ellipse.eb867724.svg";